@if (comment()) {
  <div
    class="qaroni-bg-neutral98 flex w-full flex-col gap-5 rounded border p-5">
    <div class="flex flex-col gap-3">
      <div class="flex w-full flex-row items-center gap-2.5">
        <div class="h-8 w-8">
          <img [src]="comment()?.imageUrl ?? avatar.url" [alt]="avatar.alt" />
        </div>
        <div class="flex flex-1 flex-col">
          <div class="flex w-full flex-col">
            <span class="text-sm font-semibold">{{
              comment()?.ownerName
            }}</span>
            @if (showEmployee()) {
              <span class="text-xs font-medium"
                >Dirigido a: {{ comment()?.employee }}</span
              >
            }
          </div>
          <div
            class="qaroni-text-neutral70 flex items-center gap-2 text-xs leading-5">
            <mat-icon class="qaroni-mat-icon-14">language</mat-icon>
            <span>Publicado el {{ date | date: "dd, MMM 'del' yyyy" }}</span>
          </div>
        </div>
        @if (isMyComment && showActions()) {
          <div>
            <button
              mat-icon-button
              [matMenuTriggerFor]="commentOptions"
              aria-hidden="false">
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
        }
      </div>
      <mat-divider />
    </div>
    <div class="w-full text-sm">{{ comment()?.message }}</div>
  </div>
}

<mat-menu #commentOptions="matMenu" class="bg-white">
  <button mat-menu-item (click)="onEditComment()">
    <mat-icon>edit</mat-icon>
    <span>Editar</span>
  </button>
  <button mat-menu-item (click)="onDeleteComment()">
    <mat-icon>delete</mat-icon>
    <span>Eliminar</span>
  </button>
</mat-menu>
